/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../Containers/ArgosFlexbox';
import {IArgosReportSectionProps} from '../constants';
import "highlight.js/styles/github.css";
import hljs from 'highlight.js'
import rehypeHighlight from 'rehype-highlight'
import rehypeRaw from "rehype-raw";
import remarkGfm from 'remark-gfm'
import Markdown from "react-markdown"
import React, {useEffect, useState} from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {Typography} from "@mui/material";


/**
 * Renders a Text collapse section in the FullReport view utilizing 
 * GitHub flavored markdown
 */
const Text = (props: IArgosReportSectionProps) => {
  const {data} = props
  const [textMode, setTextMode] = useState<string>('visual')

  const handleTextModeChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setTextMode(newAlignment)
  }

  useEffect(()=>{
    hljs.highlightAll();
  },[]);

  return(
    <ArgosFlexbox vertical style={{padding: "10px"}}>
      {/* TODO: the toggle buttons should show for users with "Developer" status 
          when that feature gets implemented */}
      {false && <ToggleButtonGroup
        color="primary"
        value={textMode}
        exclusive
        onChange={handleTextModeChange}
        aria-label="Platform"
      >
        <ToggleButton value="visual">Visual</ToggleButton>
        <ToggleButton value="text">Text</ToggleButton>
      </ToggleButtonGroup>}
      {textMode === 'visual' && <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, rehypeHighlight]}>
        {data}
      </Markdown>}
      {textMode === 'text' && <Typography style={{padding: "0px 0px 16px 0px"}}>
        {data.split('\n').map((line: string, index: number) => (
          <Typography key={index}>
            {line}
          </Typography>
        ))}
      </Typography>}
    </ArgosFlexbox>
  )
}

export default Text
